import { INotif } from '@/shared/model/global.model';
import { Module } from 'vuex';

export const appStore: Module<any, any> = {
  state: {
    showLoading: false,
    drawer: false,
    rightDrawer: false,
    notifs: [],
  },
  getters: {
    showLoading: state => state.showLoading,
    drawer: state => state.drawer,
    rightDrawer: state => state.rightDrawer,
    notifs: state => {
      return state.notifs;
    },
  },
  mutations: {
    showLoading(state, isShown: boolean) {
      state.showLoading = isShown;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    setDrawer(state, isOpen: boolean) {
      state.drawer = isOpen;
    },
    toggleRightDrawer(state) {
      state.rightDrawer = !state.rightDrawer;
    },
    setRightDrawer(state, isOpen: boolean) {
      state.rightDrawer = isOpen;
    },
    addNotif(state, notif: INotif) {
      const { show, icon, iconColor, message } = notif;
      const notifs = [...state.notifs];
      const newNotifs = [
        ...notifs,
        {
          show,
          icon: icon || 'mdi-check-circle',
          iconColor: iconColor || 'success',
          message,
        },
      ];
      state.notifs = newNotifs;
      setTimeout(() => {
        const notifs = [...state.notifs];
        notifs.shift();
        state.notifs = notifs;
      }, 5000);
    },
    showSuccess(state, notif: INotif) {
      const { show, icon, iconColor, message } = notif;
      const notifs = [...state.notifs];
      const newNotifs = [
        ...notifs,
        {
          show: true,
          icon: icon || 'mdi-check-circle',
          iconColor: iconColor || 'success',
          message,
        },
      ];
      state.notifs = newNotifs;
      setTimeout(() => {
        const notifs = [...state.notifs];
        notifs.shift();
        state.notifs = notifs;
      }, 5000);
    },
    showError(state, notif: INotif) {
      const { show, icon, iconColor, message } = notif;
      const notifs = [...state.notifs];
      const newNotifs = [
        ...notifs,
        {
          show: true,
          icon: icon || 'mdi-close-circle',
          iconColor: iconColor || 'error',
          message,
        },
      ];
      state.notifs = newNotifs;
      setTimeout(() => {
        const notifs = [...state.notifs];
        notifs.shift();
        state.notifs = notifs;
      }, 5000);
    },
    removeNotif(state, index?: number) {
      const notifs = [...state.notifs];
      index ? notifs.splice(index, 1) : notifs.shift();
      state.notifs = notifs;
    },
    clearAllNotif(state) {
      state.notifs = [];
    },
  },
};
